/* =============================================
   FWG Paint Protection Film — Inquiry Form
   Assets: fwg-ppf-form.js
   ============================================= */

var FWG_CONFIG = {
  SUPABASE_URL: 'https://yjpllbljqrczkfhodozi.supabase.co',
  SUPABASE_ANON_KEY: 'sb_publishable_9aGFQdl82HAw23uFfSIjCA_d4Qmi6Bp',
  API_URL: 'https://ops.frederickwraps.com',
  THANK_YOU_URL: '/pages/thank-you',
  STORAGE_BUCKET: 'form-uploads'
};

/* ── Constants ── */
var TOTAL_STEPS = 4;
var currentStep = 1;
var completedSteps = new Set();

/* ── Stepper Navigation ── */
function goToStep(target) {
  if (target < 1 || target > TOTAL_STEPS || target === currentStep) return;
  var isForward = target > currentStep;
  if (isForward) {
    for (var s = currentStep; s < target; s++) {
      var errors = getStepErrors(s);
      if (errors.length > 0) {
        highlightErrors(s, errors);
        showToast('Please fill in all required fields');
        return;
      }
      completedSteps.add(s);
    }
  }
  if (!isForward && getStepErrors(currentStep).length === 0) {
    completedSteps.add(currentStep);
  }
  switchCard(target);
}

function switchCard(target) {
  var currentCard = document.querySelector('.form-page-ppf .step-card[data-step="' + currentStep + '"]');
  if (currentCard) currentCard.classList.remove('active');
  if (target === TOTAL_STEPS) buildSummary();
  var targetCard = document.querySelector('.form-page-ppf .step-card[data-step="' + target + '"]');
  if (targetCard) {
    void targetCard.offsetWidth;
    targetCard.classList.add('active');
  }
  currentStep = target;
  updateStepper();
  var stepper = document.getElementById('ppfStepper');
  if (stepper) {
    stepper.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

/* ── Validation ── */
function getStepErrors(stepNum) {
  var errors = [];
  switch (stepNum) {
    case 1:
      if (!document.getElementById('ppfContactName').value.trim()) errors.push('ppfContactName');
      if (!document.getElementById('ppfEmail').value.trim()) errors.push('ppfEmail');
      if (!document.getElementById('ppfPhone').value.trim()) errors.push('ppfPhone');
      if (!document.getElementById('ppfContactMethodHidden').value) errors.push('contactMethod');
      break;
    case 2:
      if (!document.getElementById('ppfYear').value) errors.push('ppfYear');
      if (!document.getElementById('ppfMake').value.trim()) errors.push('ppfMake');
      if (!document.getElementById('ppfModel').value.trim()) errors.push('ppfModel');
      if (!document.getElementById('ppfCeramicHidden').value) errors.push('ceramic');
      if (!document.getElementById('ppfImperfectionsHidden').value) errors.push('imperfections');
      break;
    case 3:
      if (!document.getElementById('ppfPackageHidden').value) errors.push('package');
      break;
    case 4:
      if (!document.getElementById('ppfTimeline').value) errors.push('ppfTimeline');
      break;
  }
  return errors;
}

function highlightErrors(stepNum, errors) {
  document.querySelectorAll('.form-page-ppf .field-error').forEach(function(el) { el.classList.remove('field-error'); });
  var card = document.querySelector('.form-page-ppf .step-card[data-step="' + stepNum + '"]');
  if (!card) return;
  card.classList.remove('shake');
  void card.offsetWidth;
  card.classList.add('shake');
  errors.forEach(function(errKey) {
    switch(errKey) {
      case 'ppfContactName': case 'ppfEmail': case 'ppfPhone':
        var el = document.getElementById(errKey);
        if (el) el.closest('.field-group').classList.add('field-error');
        break;
      case 'contactMethod':
        var cm = document.querySelector('.form-page-ppf .contact-method-group');
        if (cm) cm.closest('.field-group').classList.add('field-error');
        break;
      case 'ppfYear': case 'ppfMake': case 'ppfModel':
        var vel = document.getElementById(errKey);
        if (vel) vel.closest('.field-group').classList.add('field-error');
        break;
      case 'ceramic':
        var cg = document.querySelector('.form-page-ppf .condition-btn-group[data-group="ceramic"]');
        if (cg) cg.closest('.field-group').classList.add('field-error');
        break;
      case 'imperfections':
        var ig = document.querySelector('.form-page-ppf .condition-btn-group[data-group="imperfections"]');
        if (ig) ig.closest('.field-group').classList.add('field-error');
        break;
      case 'package':
        var pg = document.querySelector('.form-page-ppf .ppf-package-grid');
        if (pg) pg.closest('.field-group').classList.add('field-error');
        break;
      case 'ppfTimeline':
        var tl = document.getElementById('ppfTimeline');
        if (tl) tl.closest('.field-group').classList.add('field-error');
        break;
    }
  });
}

document.addEventListener('input', function() {
  document.querySelectorAll('.form-page-ppf .field-error').forEach(function(el) { el.classList.remove('field-error'); });
});
document.addEventListener('click', function(e) {
  if (e.target.closest('.form-page-ppf .contact-method-btn, .form-page-ppf .condition-btn, .form-page-ppf .ppf-package-card, .form-page-ppf .finish-btn')) {
    document.querySelectorAll('.form-page-ppf .field-error').forEach(function(el) { el.classList.remove('field-error'); });
  }
});

function updateStepper() {
  document.querySelectorAll('.form-page-ppf .step-indicator').forEach(function(ind) {
    var step = parseInt(ind.dataset.step);
    ind.classList.remove('active', 'completed');
    if (step === currentStep) {
      ind.classList.add('active');
    } else if (completedSteps.has(step)) {
      ind.classList.add('completed');
    }
  });
}

/* ── Label Maps ── */
var packageLabels = {
  essentials: 'Essentials',
  partial_front: 'Partial Front',
  full_front: 'Full Front',
  full_front_plus: 'Full Front+',
  full_vehicle: 'Full Vehicle Coverage'
};
var packagePrices = {
  essentials: 'Starting at $395',
  partial_front: 'Starting at $1,295',
  full_front: 'Starting at $1,895',
  full_front_plus: 'Starting at $2,595',
  full_vehicle: 'Contact for quote'
};
var finishLabels = { gloss:'Gloss', matte:'Matte', satin:'Satin', colored:'Colored / Cosmetic' };
var timelineLabels = {
  asap: 'ASAP / As soon as possible',
  '30_days': 'Within 30 days',
  '30_60_days': '30\u201360 days',
  '60_90_days': '60\u201390+ days',
  planning: 'Just planning / gathering info'
};

/* ── Contact Method ── */
function selectContactMethod(btn) {
  document.querySelectorAll('.form-page-ppf .contact-method-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('ppfContactMethodHidden').value = btn.dataset.value;
}

/* ── Ceramic Coating Logic ── */
function selectCondition(group, btn) {
  var btns = document.querySelectorAll('.form-page-ppf .condition-btn-group[data-group="' + group + '"] .condition-btn');
  btns.forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');

  if (group === 'ceramic') {
    document.getElementById('ppfCeramicHidden').value = btn.dataset.value;
    var yesPanel = document.getElementById('ppfCeramicYesPanel');
    var noPanel = document.getElementById('ppfCeramicNoPanel');
    if (btn.dataset.value === 'yes') {
      yesPanel.classList.add('visible');
      noPanel.classList.remove('visible');
      // Reset the ceramic-after question
      document.getElementById('ppfCeramicAfterHidden').value = '';
      noPanel.querySelectorAll('.condition-btn').forEach(function(b) { b.classList.remove('selected'); });
      document.getElementById('ppfCeramicAfterPanel').classList.remove('visible');
    } else {
      yesPanel.classList.remove('visible');
      noPanel.classList.add('visible');
    }
  } else if (group === 'ceramic_after') {
    document.getElementById('ppfCeramicAfterHidden').value = btn.dataset.value;
    var afterPanel = document.getElementById('ppfCeramicAfterPanel');
    if (btn.dataset.value === 'yes') {
      afterPanel.classList.add('visible');
    } else {
      afterPanel.classList.remove('visible');
    }
  } else if (group === 'imperfections') {
    document.getElementById('ppfImperfectionsHidden').value = btn.dataset.value;
    var details = document.getElementById('ppfImperfectionsDetails');
    if (btn.dataset.value === 'yes') {
      details.classList.add('visible');
    } else {
      details.classList.remove('visible');
    }
  }
}

/* ── PPF Package Selection ── */
function selectPackage(card) {
  document.querySelectorAll('.form-page-ppf .ppf-package-card').forEach(function(c) { c.classList.remove('selected'); });
  card.classList.add('selected');
  document.getElementById('ppfPackageHidden').value = card.dataset.value;

  // Show/hide finish section (Full Vehicle only)
  var finishSection = document.getElementById('ppfFinishSection');
  if (card.dataset.value === 'full_vehicle') {
    finishSection.classList.add('visible');
  } else {
    finishSection.classList.remove('visible');
    // Reset finish selection
    document.getElementById('ppfFinishHidden').value = '';
    document.querySelectorAll('.form-page-ppf .finish-btn').forEach(function(b) { b.classList.remove('selected'); });
    document.getElementById('ppfColoredDetails').classList.remove('visible');
  }
}

/* ── Finish Selection ── */
function selectFinish(btn) {
  document.querySelectorAll('.form-page-ppf .finish-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('ppfFinishHidden').value = btn.dataset.value;

  var coloredDetails = document.getElementById('ppfColoredDetails');
  if (btn.dataset.value === 'colored') {
    coloredDetails.classList.add('visible');
  } else {
    coloredDetails.classList.remove('visible');
  }
}

/* ── Add-on Toggles ── */
function toggleAddon(el) {
  el.classList.toggle('selected');
  var key = el.dataset.addon;
  document.getElementById('ppfAddon_' + key).value = el.classList.contains('selected') ? 'yes' : '';
}

/* ── Color Pickers ── */
var vehicleColors = [
  {value:'white',label:'White',hex:'#FFFFFF'},{value:'black',label:'Black',hex:'#1A1A1A'},
  {value:'gray',label:'Gray',hex:'#808080'},{value:'silver',label:'Silver',hex:'#C0C0C0'},
  {value:'blue',label:'Blue',hex:'#2B5EA7'},{value:'red',label:'Red',hex:'#C0392B'},
  {value:'brown',label:'Brown',hex:'#6B4226'},{value:'green',label:'Green',hex:'#2E7D32'},
  {value:'beige',label:'Beige / Tan',hex:'#C8B88A'},{value:'yellow',label:'Yellow',hex:'#F1C40F'},
  {value:'orange',label:'Orange',hex:'#E67E22'},{value:'other',label:'Other',hex:null}
];

function toggleColorDropdown(pickerId) {
  var pk = document.getElementById(pickerId);
  var tr = pk.querySelector('.color-picker__trigger');
  var dd = pk.querySelector('.color-picker__dropdown');
  // Close other dropdowns
  document.querySelectorAll('.form-page-ppf .color-picker__dropdown.open').forEach(function(d) {
    if (d !== dd) { d.classList.remove('open'); d.closest('.color-picker').querySelector('.color-picker__trigger').classList.remove('open'); }
  });
  var o = dd.classList.toggle('open');
  tr.classList.toggle('open', o);
}

function selectColor(pickerId, optEl) {
  var val = optEl.dataset.value;
  var label = optEl.dataset.label;
  var hex = optEl.dataset.hex;
  var pk = document.getElementById(pickerId);
  pk.querySelectorAll('.color-picker__option').forEach(function(o) { o.classList.remove('selected'); });
  optEl.classList.add('selected');
  var trigger = pk.querySelector('.color-picker__trigger');
  var swatch = trigger.querySelector('.color-picker__trigger-swatch');
  var labelEl = trigger.querySelector('.color-picker__trigger-label');
  var otherInput = pk.querySelector('.color-picker__other-input');
  var hidden = pk.querySelector('.color-picker__hidden');

  if (val === 'other') {
    swatch.style.cssText = 'background:linear-gradient(135deg,#E8E8E8 25%,#D0D0D0 25%,#D0D0D0 50%,#E8E8E8 50%,#E8E8E8 75%,#D0D0D0 75%);background-size:8px 8px;';
    swatch.innerHTML = '<span style="font-size:12px;font-weight:700;color:#7D7D7D;">?</span>';
    labelEl.textContent = 'Other';
    labelEl.className = 'color-picker__trigger-label';
    otherInput.classList.add('visible');
    hidden.value = 'other:' + otherInput.value;
  } else {
    swatch.style.cssText = 'background:' + hex + ';';
    swatch.innerHTML = '';
    labelEl.textContent = label;
    labelEl.className = 'color-picker__trigger-label';
    otherInput.classList.remove('visible');
    hidden.value = val;
  }
  pk.querySelector('.color-picker__dropdown').classList.remove('open');
  trigger.classList.remove('open');
}

document.addEventListener('click', function(e) {
  if (!e.target.closest('.form-page-ppf .color-picker')) {
    document.querySelectorAll('.form-page-ppf .color-picker__dropdown.open').forEach(function(d) {
      d.classList.remove('open');
      d.closest('.color-picker').querySelector('.color-picker__trigger').classList.remove('open');
    });
  }
});
document.addEventListener('input', function(e) {
  if (e.target.classList.contains('color-picker__other-input') && e.target.closest('.form-page-ppf')) {
    e.target.closest('.color-picker').querySelector('.color-picker__hidden').value = 'other:' + e.target.value;
  }
});

/* ── Summary Builder ── */
function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

function summaryRow(label, value) {
  return '<div class="summary__row"><span class="summary__label">' + label + '</span><span class="summary__value">' + (value || '<span style="color:#B0B0B0;">\u2014</span>') + '</span></div>';
}

function editBtn(step) {
  return '<button type="button" class="btn-edit" onclick="goToStep(' + step + ')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg> Edit</button>';
}

function sectionHeader(num, title, step) {
  return '<div class="summary__section-header"><div class="summary__section-title"><span class="summary__section-num">' + num + '</span> ' + title + '</div>' + editBtn(step) + '</div>';
}

function resolveColor(pickerId) {
  var hidden = document.querySelector('#' + pickerId + ' .color-picker__hidden');
  if (!hidden || !hidden.value) return '\u2014';
  var val = hidden.value;
  if (val.indexOf('other:') === 0) return val.substring(6) || 'Other';
  var match = vehicleColors.find(function(c) { return c.value === val; });
  return match ? match.label : val;
}

function buildSummary() {
  var html = '';

  // Contact
  html += '<div class="summary__section">';
  html += sectionHeader('01', 'Contact Info', 1);
  html += summaryRow('Name', esc(document.getElementById('ppfContactName').value));
  html += summaryRow('Email', esc(document.getElementById('ppfEmail').value));
  html += summaryRow('Phone', esc(document.getElementById('ppfPhone').value));
  var cm = document.getElementById('ppfContactMethodHidden').value;
  html += summaryRow('Preferred', cm === 'email' ? 'Email' : cm === 'text' ? 'Text' : cm === 'call' ? 'Call' : '');
  html += '</div>';

  // Vehicle
  html += '<div class="summary__section">';
  html += sectionHeader('02', 'Vehicle Details', 2);
  html += summaryRow('Year', esc(document.getElementById('ppfYear').value));
  html += summaryRow('Make', esc(document.getElementById('ppfMake').value));
  html += summaryRow('Model', esc(document.getElementById('ppfModel').value));
  html += summaryRow('Color', esc(resolveColor('ppfVehicleColorPicker')));

  var ceramicVal = document.getElementById('ppfCeramicHidden').value;
  html += summaryRow('Ceramic Coated', ceramicVal === 'yes' ? 'Yes' : 'No');
  if (ceramicVal === 'no') {
    var ceramicAfter = document.getElementById('ppfCeramicAfterHidden').value;
    if (ceramicAfter === 'yes') html += summaryRow('Ceramic After PPF', 'Yes \u2014 interested in ceramic-infused PPF');
    else if (ceramicAfter === 'no') html += summaryRow('Ceramic After PPF', 'No');
  }

  var impVal = document.getElementById('ppfImperfectionsHidden').value;
  html += summaryRow('Imperfections', impVal === 'yes' ? 'Yes' : 'No');
  if (impVal === 'yes') {
    var impDesc = document.getElementById('ppfImperfectionsDesc').value.trim();
    if (impDesc) html += summaryRow('Details', esc(impDesc));
  }
  html += '</div>';

  // Package
  html += '<div class="summary__section">';
  html += sectionHeader('03', 'PPF Package', 3);
  var pkg = document.getElementById('ppfPackageHidden').value;
  html += summaryRow('Package', packageLabels[pkg] || '\u2014');
  html += summaryRow('Price', packagePrices[pkg] || '\u2014');
  if (pkg === 'full_vehicle') {
    var finish = document.getElementById('ppfFinishHidden').value;
    if (finish) html += summaryRow('Finish', finishLabels[finish] || '\u2014');
    if (finish === 'colored') {
      html += summaryRow('PPF Color', esc(resolveColor('ppfFilmColorPicker')));
      var colorDesc = document.getElementById('ppfColoredDesc').value.trim();
      if (colorDesc) html += summaryRow('Color Notes', esc(colorDesc));
    }
  }
  // Add-ons
  var addons = [];
  if (document.getElementById('ppfAddon_window_tint').value === 'yes') addons.push('Window Tint');
  if (document.getElementById('ppfAddon_chrome_delete').value === 'yes') addons.push('Chrome Delete');
  if (document.getElementById('ppfAddon_styling_graphics').value === 'yes') addons.push('Styling Graphics');
  if (addons.length > 0) html += summaryRow('Add-ons', esc(addons.join(', ')));
  html += '</div>';

  document.getElementById('ppfSummaryContainer').innerHTML = html;
}

/* ── Toast ── */
function showToast(m) {
  var t = document.getElementById('ppfToast');
  t.textContent = m;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2200);
}

/* ── File Names Display ── */
function showFileNames(i, uid) {
  var el = document.querySelector('#' + uid + ' .file-names');
  el.textContent = i.files.length ? Array.from(i.files).map(function(f) { return f.name; }).join(', ') : '';
}

/* ── File Upload to Supabase ── */
function uploadFile(file, folder) {
  var timestamp = Date.now();
  var safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  var path = folder + '/' + timestamp + '_' + safeName;
  return fetch(
    FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path,
    {
      method: 'POST',
      headers: {
        'apikey': FWG_CONFIG.SUPABASE_ANON_KEY,
        'Authorization': 'Bearer ' + FWG_CONFIG.SUPABASE_ANON_KEY,
        'Content-Type': file.type,
        'x-upsert': 'true'
      },
      body: file
    }
  ).then(function(response) {
    if (!response.ok) {
      return response.text().then(function(t) { console.error('Upload failed:', file.name, t); return null; });
    }
    return FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/public/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path;
  });
}

function uploadFiles(fileInput, folder) {
  if (!fileInput || !fileInput.files || fileInput.files.length === 0) return Promise.resolve([]);
  var promises = [];
  for (var i = 0; i < fileInput.files.length; i++) {
    promises.push(uploadFile(fileInput.files[i], folder));
  }
  return Promise.all(promises).then(function(urls) {
    return urls.filter(function(u) { return u !== null; });
  });
}

/* ── Submit Handler ── */
document.addEventListener('DOMContentLoaded', function() {

  document.getElementById('fwgPpfForm').addEventListener('submit', function(e) {
    e.preventDefault();

    for (var i = 1; i <= TOTAL_STEPS; i++) {
      var errors = getStepErrors(i);
      if (errors.length > 0) {
        switchCard(i);
        (function(step, errs) {
          setTimeout(function() { highlightErrors(step, errs); }, 50);
        })(i, errors);
        showToast('Please fill in all required fields');
        return;
      }
    }

    var submitBtn = document.querySelector('.form-page-ppf .btn-submit');
    var originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;"><svg width="18" height="18" viewBox="0 0 24 24" style="animation:spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="31 31" stroke-linecap="round"/></svg> Submitting...</span>';
    }

    var submissionId = Date.now() + '_' + Math.random().toString(36).substring(2, 8);
    var folder = 'submissions/' + submissionId;

    var vehiclePhotoInput = document.querySelector('input[name="ppf_vehicle_photos"]');
    var imperfectionPhotoInput = document.querySelector('input[name="ppf_imperfection_photos"]');
    var refPhotoInput = document.querySelector('input[name="ppf_ref_images"]');
    var coloredInspoInput = document.querySelector('input[name="ppf_colored_inspo"]');

    var vehiclePhotoUrls = [];
    var imperfectionPhotoUrls = [];
    var refPhotoUrls = [];
    var coloredInspoUrls = [];

    uploadFiles(vehiclePhotoInput, folder + '/vehicle_photos')
    .then(function(urls) {
      vehiclePhotoUrls = urls;
      return uploadFiles(imperfectionPhotoInput, folder + '/imperfection_photos');
    })
    .then(function(urls) {
      imperfectionPhotoUrls = urls;
      return uploadFiles(refPhotoInput, folder + '/reference');
    })
    .then(function(urls) {
      refPhotoUrls = urls;
      return uploadFiles(coloredInspoInput, folder + '/colored_inspo');
    })
    .then(function(urls) {
      coloredInspoUrls = urls;

      // Resolve vehicle color
      var vColorRaw = document.querySelector('#ppfVehicleColorPicker .color-picker__hidden').value;
      var vColor = vColorRaw;
      var vColorOther = '';
      if (vColorRaw.indexOf('other:') === 0) { vColor = 'other'; vColorOther = vColorRaw.substring(6); }

      // Resolve film color (if colored finish)
      var fColorRaw = document.querySelector('#ppfFilmColorPicker .color-picker__hidden').value;
      var fColor = fColorRaw;
      var fColorOther = '';
      if (fColorRaw.indexOf('other:') === 0) { fColor = 'other'; fColorOther = fColorRaw.substring(6); }

      var pkg = document.getElementById('ppfPackageHidden').value;
      var addons = [];
      if (document.getElementById('ppfAddon_window_tint').value === 'yes') addons.push('window_tint');
      if (document.getElementById('ppfAddon_chrome_delete').value === 'yes') addons.push('chrome_delete');
      if (document.getElementById('ppfAddon_styling_graphics').value === 'yes') addons.push('styling_graphics');

      var payload = {
        form_type: 'ppf',
        contact_name: document.getElementById('ppfContactName').value.trim(),
        email: document.getElementById('ppfEmail').value.trim(),
        phone: document.getElementById('ppfPhone').value.trim(),
        contact_method: document.getElementById('ppfContactMethodHidden').value,
        vehicles: [{
          year: document.getElementById('ppfYear').value,
          make: document.getElementById('ppfMake').value.trim(),
          model: document.getElementById('ppfModel').value.trim(),
          color: vColor,
          color_other: vColorOther,
          ceramic_coated: document.getElementById('ppfCeramicHidden').value === 'yes',
          ceramic_after_ppf: document.getElementById('ppfCeramicAfterHidden').value === 'yes',
          has_imperfections: document.getElementById('ppfImperfectionsHidden').value === 'yes',
          imperfections_description: document.getElementById('ppfImperfectionsDesc').value.trim() || null,
          imperfection_photo_urls: imperfectionPhotoUrls,
          photo_urls: vehiclePhotoUrls
        }],
        ppf_package: pkg,
        ppf_finish: pkg === 'full_vehicle' ? (document.getElementById('ppfFinishHidden').value || null) : null,
        ppf_film_color: (pkg === 'full_vehicle' && document.getElementById('ppfFinishHidden').value === 'colored') ? fColor : null,
        ppf_film_color_other: (pkg === 'full_vehicle' && document.getElementById('ppfFinishHidden').value === 'colored') ? fColorOther : null,
        ppf_colored_description: (pkg === 'full_vehicle' && document.getElementById('ppfFinishHidden').value === 'colored') ? (document.getElementById('ppfColoredDesc').value.trim() || null) : null,
        ppf_colored_inspo_urls: coloredInspoUrls,
        addons: addons,
        timeline: document.getElementById('ppfTimeline').value,
        additional_info: (document.getElementById('ppfAdditionalInfo') || {}).value || null,
        reference_image_urls: refPhotoUrls,
        source_page: window.location.pathname,
        user_agent: navigator.userAgent
      };

      return fetch(FWG_CONFIG.API_URL + '/api/submissions/public', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    })
    .then(function(response) {
      if (!response.ok) {
        return response.text().then(function(t) { throw new Error('Submission failed: ' + t); });
      }
      showToast('Quote request submitted!');
      setTimeout(function() {
        window.location.href = FWG_CONFIG.THANK_YOU_URL;
      }, 800);
    })
    .catch(function(err) {
      console.error('Form submission error:', err);
      showToast('Something went wrong. Please try again or call us directly.');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      }
    });
  });

});
